import { FETCH_ENROLLMENT_CONVERSION_DETAILS } from 'automation-ui-canvas/containers/enrollment-conversion/wireGetEnrollmentConversionDetails';
import { useApplicationHistoryFilters } from 'automation-ui-management/hooks/filterHooks';
import { getTimestampsFromHistoryFilters } from 'automation-ui-management/records/ApplicationHistoryFilters/ApplicationHistoryFilterUtils';
import { useQuery } from 'data-fetching-client';
export const useGetConversionMetrics = (flow, isReportingEnabled) => {
  const {
    filters
  } = useApplicationHistoryFilters();
  const timeStamps = getTimestampsFromHistoryFilters(filters);
  const {
    data,
    loading: isConversionDataLoading
  } = useQuery(FETCH_ENROLLMENT_CONVERSION_DETAILS, {
    variables: {
      flow,
      startTimestamp: timeStamps === null || timeStamps === void 0 ? void 0 : timeStamps.startTimestamp,
      endTimestamp: timeStamps === null || timeStamps === void 0 ? void 0 : timeStamps.endTimestamp
    },
    skip: !isReportingEnabled || !timeStamps || !timeStamps.startTimestamp || !timeStamps.endTimestamp || timeStamps.startTimestamp > timeStamps.endTimestamp
  });
  return {
    enrollmentConversionData: data === null || data === void 0 ? void 0 : data.fetchEnrollmentConversionDetails,
    isConversionDataLoading
  };
};